import React from 'react';
import { motion } from 'motion/react';

type VantiTableSpec = {
  title?: string;
  columns: string[];
  rows: (string | number | null)[][];
};

export default function VantiTable({ spec }: { spec: VantiTableSpec }) {
  if (!spec?.columns?.length || !spec?.rows?.length) return null;

  return (
    <motion.div layout={false} className="my-3 overflow-hidden rounded-xl border border-dark-border bg-dark-surface">
      {spec.title && (
        <div className="border-b border-dark-border px-4 py-2.5 text-xs font-semibold text-slate-300">
          {spec.title}
        </div>
      )}
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead>
            <tr className="border-b border-dark-border bg-dark-elevated">
              {spec.columns.map((col, i) => (
                <th
                  key={i}
                  className="px-4 py-2 text-left font-semibold text-slate-400"
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {spec.rows.map((row, ri) => (
              <tr
                key={ri}
                className={`border-b border-dark-border/50 transition-colors hover:bg-dark-elevated/50 ${
                  ri % 2 === 0 ? '' : 'bg-dark-elevated/20'
                }`}
              >
                {spec.columns.map((_, ci) => {
                  const cell = row[ci] ?? '—';
                  return (
                    <td key={ci} className="px-4 py-2 text-slate-300">
                      {String(cell)}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </motion.div>
  );
}
